import { render } from "./DateFilter.vue?vue&type=template&id=1682495a"
import script from "./DateFilter.vue?vue&type=script&lang=js"
export * from "./DateFilter.vue?vue&type=script&lang=js"
script.render = render

export default script